import _ from 'underscore';

import { LocationMapper } from '~src/personalSpace/model/mappers/LocationMapper';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { IViewUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import { IIdItem } from '~src/spacesPlatform/models/resourceParts';
import { UserMapper } from '~src/userManagement/users/models/mappers/UserMapper';
import { ViewMapper } from '~src/views/mappers/ViewMapper';
import { WorkbookMapper } from '~src/workbook/models/mappers/WorkbookMapper';

import { IBroadcastDetail } from '../models/IBroadcastContentInfo';
import { IGetBroadcastsResult } from './requests/GetBroadcastViewsRequest';
import { IGetDetailBroadcastResult } from './requests/GetDetailOfABroadcastRequest';

export module BroadcastServerApiHelper {

    export function broadcastItems(broadcastsResult: IGetBroadcastsResult): IContentInfo[] {
        if (broadcastsResult?.views?.length > 0) {
            const users = index(UserMapper.map(broadcastsResult.users));
            const locations = LocationMapper.map(broadcastsResult.containers);
            const workbooks = index(WorkbookMapper.mapParents(broadcastsResult.workbooks, users, {}, locations));
            const views = ViewMapper.map(broadcastsResult.views, workbooks, <IViewUsageInfo>{}, favorites(broadcastsResult.viewFavorites));
            return views;
        }
        return [];
    }

    function index<T extends IIdItem>(items: ReadonlyArray<T>): _.Dictionary<T> {
        return _.indexBy(items, 'id');
    }

    function favorites(ids: string[]) {
        return _.indexBy(ids, _.identity);
    }

    export function broadcastDetail(result: IGetDetailBroadcastResult): IBroadcastDetail {
        const broadcastItem = {
            id: result.id,
            workbookId: result.workbookId,
            workbookLuid: result.workbookLuid,
            broadcastWorkbookName: result.broadcastWorkbookName,
            viewId: result.viewId,
            viewLuid: result.viewLuid,
            broadcastViewName: result.broadcastViewName,
            publicFacingUrl: result.publicFacingUrl,
        };
        return broadcastItem;
    }
}